.pair {
	margin-block: var(--mantine-spacing-md);

	/* Both panes come from the viewer's fence renderer, which gives each its own
	 * block spacing and rounded, bordered shell. The selectors below reach into that
	 * markup structurally, because its class names are hashed inside the kit's CSS
	 * modules and cannot be named here. Joining the two panes belongs in
	 * @surrealdb/ui alongside the renderer; until it moves there, keep these rules
	 * tied to structure and to the `data-language` attribute the renderer sets. */
	> * + * {
		margin-top: 0;
	}

	/* Code pane: keep the top corners, drop the bottom ones and the shared seam. */
	> *:first-child pre[data-language] {
		border-bottom-left-radius: 0;
		border-bottom-right-radius: 0;
		border-bottom: 0;
	}

	/* The output fence's caption becomes the divider between the two panes. */
	> *:last-child > *:first-child {
		border-top-left-radius: 0;
		border-top-right-radius: 0;
	}
}
